import { useQuery } from '@tanstack/react-query'
import { fetchDistrict } from '@/services/districts'

export function useDistrict(id: string | undefined) {
  const districtQuery = useQuery({
    queryKey: ['district', id],
    queryFn: () => fetchDistrict(id!),
    enabled: !!id,
  })

  return {
    district: districtQuery.data,
    isLoading: districtQuery.isLoading,
    error: districtQuery.error,
  }
}
